/** @format */

import React from 'react'
import _ from 'lodash'

import './style.css'

export function Container(props) {
  const className = _(['game', props.flex && 'flex', props.className])
    .compact()
    .join(' ')

  const style = {}

  if (props.theme) {
    style.backgroundColor = props.theme
  }

  if (props.bgImg) {
    style.backgroundImage = props.bgImg
  }

  return (
    <div className={className} style={style}>
      {props.children}
      <div className="game-footer">
        <p>
          Vuse products contain nicotine, which is a highly
          <br className="mobile-only" /> addictive substance, adult smokers and
          vapers 18+ only.
        </p>
      </div>
    </div>
  )
}

export default Container
